import React from 'react';
import PropTypes from 'prop-types';

const EachSideAdminContentHandler = props => {
  const { children, value, index } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      style={{
        display: value !== index ? 'none' : 'flex',
        flexDirection: 'column',
        flex: 1,
        minHeight: 0,
      }}
    >
      {value === index ? children : null}
    </div>
  );
};
EachSideAdminContentHandler.propTypes = {
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
  children: PropTypes.element.isRequired,
};
export default EachSideAdminContentHandler;
